import { useUser } from "@clerk/clerk-react";
import { identifyUserPostHog, startSessionRecordingPostHog } from "@/lib/posthogAnalytics";
import { useEffect, useRef } from "react";

/**
 * Enlaza la sesión anónima de PostHog con el usuario de Clerk al iniciar sesión.
 * Corre dentro de AppClerkProvider para tener useUser disponible.
 */
export function ClerkPostHogIdentify() {
  const { user, isLoaded, isSignedIn } = useUser();
  const lastIdentifiedId = useRef<string | null>(null);

  useEffect(() => {
    if (!isLoaded || !isSignedIn || !user?.id) return;
    if (lastIdentifiedId.current === user.id) return;
    lastIdentifiedId.current = user.id;

    const email = user.primaryEmailAddress?.emailAddress;
    identifyUserPostHog(user.id, {
      email: email ?? undefined,
      clerk_user_id: user.id,
      clerk_created_at: user.createdAt
        ? new Date(user.createdAt).toISOString()
        : undefined,
      has_verified_email: Boolean(
        user.primaryEmailAddress?.verification?.status === "verified",
      ),
    });
    // identify no habilita replay por sí solo — refuerzo tras merge anónimo → Clerk.
    startSessionRecordingPostHog();
  }, [isLoaded, isSignedIn, user]);

  return null;
}